// extracted by mini-css-extract-plugin
export default {"stepList":"Ingredient_stepList__C5WCQ","step":"Ingredient_step__LSCxd"};